import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import logo from "../logo.png";

const links = [
  { label: "Why iGrade", path: "/about" },
  { label: "Programs", path: "/programs" },
  { label: "Success Stories", path: "/success-stories" },
  { label: "Process", path: "/process" },
  { label: "Blogs", path: "/blogs" },
  { label: "FAQ", path: "/faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkStyle = {
    color: "rgba(255,255,255,0.8)",
    fontSize: 14,
    fontWeight: 500,
    textDecoration: "none",
    transition: "0.2s",
  };

  return (
    <>
      <nav
        style={{
          position: "fixed",
          top: 0,
          width: "100%",
          zIndex: 999,
          background: scrolled
            ? "rgba(7,21,53,0.98)"
            : "rgba(11,31,74,0.96)",
          backdropFilter: "blur(16px)",
          borderBottom: "1px solid rgba(245,197,24,0.2)",
          transition: "0.35s",
          padding: "0 4%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: scrolled ? "62px" : "74px",
        }}
      >
        {/* Logo */}

        <Link
          to="/"
          style={{ display: "flex", alignItems: "center" }}
        >
          <img
            src={logo}
            alt="iGrade Education"
            style={{
              height: scrolled ? "40px" : "52px",
              width: "auto",
              transition: "0.35s",
              background: "#fff",
              borderRadius: 8,
              padding: "4px 8px",
            }}
          />
        </Link>

        {/* Desktop */}

        <div
          className="desktop-nav"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 32,
          }}
        >
          {links.map((item) => (
            <Link
              key={item.label}
              to={item.path}
              style={linkStyle}
              onMouseEnter={(e) =>
                (e.target.style.color = "var(--yellow)")
              }
              onMouseLeave={(e) =>
                (e.target.style.color =
                  "rgba(255,255,255,0.8)")
              }
            >
              {item.label}
            </Link>
          ))}

          <Link
            to="/contact"
            style={{
              background: "var(--yellow)",
              color: "var(--navy)",
              padding: "10px 22px",
              borderRadius: 8,
              fontWeight: 700,
              fontSize: 14,
              textDecoration: "none",
              transition: "0.2s",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "var(--yellow2)";
              e.target.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "var(--yellow)";
              e.target.style.transform = "translateY(0)";
            }}
          >
            Book Free Counselling →
          </Link>
        </div>

        {/* Mobile */}

        <button
          className="hamburger"
          onClick={() => setOpen(!open)}
          style={{
            display: "none",
            background: "none",
            border: "none",
            cursor: "pointer",
            flexDirection: "column",
            gap: 5,
          }}
        >
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              style={{
                width: 24,
                height: 2,
                background: "#fff",
                display: "block",
              }}
            />
          ))}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -25 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -25 }}
            style={{
              position: "fixed",
              top: 62,
              left: 0,
              right: 0,
              zIndex: 998,
              background: "var(--navy3)",
              padding: "24px 6%",
              display: "flex",
              flexDirection: "column",
              gap: 16,
            }}
          >
            {links.map((item) => (
              <Link
                key={item.label}
                to={item.path}
                onClick={() => setOpen(false)}
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  fontSize: 16,
                  padding: "8px 0",
                  borderBottom:
                    "1px solid rgba(255,255,255,0.08)",
                }}
              >
                {item.label}
              </Link>
            ))}

            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              style={{
                background: "var(--yellow)",
                color: "var(--navy)",
                padding: "14px",
                textAlign: "center",
                borderRadius: 8,
                fontWeight: 700,
                textDecoration: "none",
              }}
            >
              Book Free Counselling →
            </Link>
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        @media(max-width:900px){
          .desktop-nav{display:none !important;}
          .hamburger{display:flex !important;}
        }
      `}</style>
    </>
  );
}